import * as ActionType from '../constants/ActionType'

export const initialState = {
    "lastUpdate": null,
    "loading": false,
    "data": [],
    "showApprovalSuccess":false
}

function configurator(state = initialState, action) {
    switch (action.type) {
        case ActionType.RECEIVE_APPROVAL_SUCCESS:
            return {
                ...state,
                loading: true,
                showApprovalSuccess: true
            };
        case ActionType.RECEIVE_APPROVAL_SUCCESS_HIDE:
            return {
                ...state,
                loading: true,
                showApprovalSuccess: false
            };
        case ActionType.REQUEST_CONFIGURATOR_DATA:
            return {
                ...state,
                lastUpdate: new Date().getTime(),
                loading: true
            };
        case ActionType.REFRESH_CONFIGURATOR_DATA:
            return {
                ...state,
                lastUpdate: new Date().getTime(),
                loading: false,
                data: []
            };
        case ActionType.RECEIVE_CONFIGURATOR_DATA:
            // push new json to data collection
            var tempData = [];
            var isUpdated = false;
            state.data.map(function (entry, i) {
                if (entry.id.toString() === action.json.id.toString()) {
                    tempData.push(action.json);
                    isUpdated = true;
                } else {
                    tempData.push(entry);
                }
            });
            if (!isUpdated) {
                tempData.push(action.json);
            }

            return {
                ...state,
                loading: false,
                lastUpdate: new Date().getTime(),
                data: tempData
            };
        default:
            return state
    }
}

export default configurator;


// WEBPACK FOOTER //
// ./src/js/reducers/configurator.js